/* eslint-disable */
import React from 'react';
import styled from 'styled-components';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  height: auto;
`;

const Content = styled(FlexBox)`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  text-align: center;
  font-family: ${({ theme }) => theme.fontIBMExtraLight};
  position: relative;
  align-content: start;
`;
const Row = styled(FlexBox)`
  align-content: start;
  > .table-cell {
    height: auto;
    overflow: hidden;
    width: 1260px;
    margin: 0 auto;
  }
  &.static {
    width: 100%;
    padding-top: 200px;
    background: url(${require('./imgs/about-banner.jpg')}) center center;
    background-size: cover;
    height: calc(100vh - 60px);
    @media screen and (max-height: 768px) {
      min-height: 559px;
    }
  }
  &.absolute {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 100px;
    @media screen and (max-height: 768px) {
      position: static;
      background: #0b0e11;
      padding: 90px 0;
    }
  }
`;
const Title = styled.div`
  color: #fff;
  font-size: 70px;
  font-weight: 300;
  margin-bottom: 40px;
`;
const Description = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-size: 24px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontIBMRegular};
`;

const Item = styled(FlexBox)`
  width: 1112px;
  margin: 0 auto;
  color: #fff;
  > div {
    > h3 {
      font-size: 64px;
      margin-bottom: 15px;
      padding: 0;
      font-family: ${({ theme }) => theme.fontIBMLight};
    }
    > p {
      color: rgba(255, 255, 255, 0.8);
      font-size: 20px;
      margin: 0;
      padding: 0;
      font-family: ${({ theme }) => theme.fontIBMRegular};
    }
  }
`;

type Props = {
  i18n: Object,
};

export default
@withI18n
class Banner extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
  };

  render() {
    const { i18n } = this.props;
    return (
      <WrapperBox direction="column">
        <Content>
          <Row align="center" justify="center" className="static">
            <div className="table-cell">
              <Title>{getLabel('exchange-banner-title', i18n)}</Title>
              <Description>{getLabel(`exchange-banner-beyond`, i18n)}</Description>
            </div>
          </Row>
          <Row className="absolute">
            <div className="table-cell">
              <Item justify="space-between">
                <div>
                  <h3>1.2 bn</h3>
                  <p>{getLabel('exchange-banner-averageDailyVolume', i18n)}</p>
                </div>
                <div>
                  <h3>1,400,000+</h3>
                  <p>{getLabel('exchange-banner-transactionsPerSecond', i18n)}</p>
                </div>
                <div>
                  <h3>24/7</h3>
                  <p>{getLabel('exchange-banner-support', i18n)}</p>
                </div>
              </Item>
            </div>
          </Row>
        </Content>
      </WrapperBox>
    );
  }
}
